import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import IndividualBenchmarkingComponent from '../components/individualbenchmarking/IndividualBenchmarkingComponent';

const IndividualBenchmarking = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <h1>{t('individualBenchmarking.name')}</h1>

      <div className='mt-4'>
        <IndividualBenchmarkingComponent />
      </div>
    </Fragment>
  );
};

export default IndividualBenchmarking;
